<template>
  <span
      class="is-clickable has-text-grey-dark resetBtn"
      v-on:click.stop.prevent="$emit('reset')"
  >X</span>
</template>

<script>
export default {
  name: "ResetFilterButton"
}
</script>

<style scoped>
.resetBtn {
  border-radius: 50%;
  background: #f7fafd;
  padding: 2px 6px;
  margin-left: 10px;
  margin-right: -12px;
}
</style>